module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/container-buildings-29546455c2211ad66e5ff9149d09620f.jpg";